var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYellowCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Yellow_card 1",
    clipPath: "url(#clip0_3_6637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.5,
    d: "M12.975 20.0561H2.32495C1.28942 20.0561 0.449951 19.2086 0.449951 18.1631V2.8674C0.449951 1.82191 1.28942 0.974373 2.32495 0.974373H12.975C14.0105 0.974373 14.85 1.82191 14.85 2.8674V18.1631C14.85 19.2086 14.0105 20.0561 12.975 20.0561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.75 20.1318H2.25C1.21447 20.1318 0.375 19.2843 0.375 18.2388V3.09457C0.375 2.04908 1.21447 1.20154 2.25 1.20154H12.75C13.7855 1.20154 14.625 2.04908 14.625 3.09457V18.2388C14.625 19.2843 13.7855 20.1318 12.75 20.1318Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.525 19.7532H2.475C1.52231 19.7532 0.75 18.9735 0.75 18.0116V3.32173C0.75 2.35987 1.52231 1.58014 2.475 1.58014H12.525C13.4777 1.58014 14.25 2.35987 14.25 3.32173V18.0116C14.25 18.9735 13.4777 19.7532 12.525 19.7532Z",
    fill: "url(#paint0_linear_3_6637)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_6637",
    x1: -0.274519,
    y1: 19.4761,
    x2: 6.57284,
    y2: 7.72905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_6637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 19.6875,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 20.5104)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCard);
export default __webpack_public_path__ + "static/media/YellowCard.ec1d61fed8fcb3bd99c99fc07fde2847.svg";
export { ForwardRef as ReactComponent };